export enum EditStatus {
    SUCCESS = 'SUCCESS',
    ERROR = 'ERROR',
    NOT_PERFORMED = 'NOT_PERFORMED',
    CHECK_FAILURE = 'CHECK_FAILURE',
    ERROR_DOCUMENTS = 'ERROR_DOCUMENTS',
    NO_EMAIL_ERROR = 'EMAIL_NOT_FOUND_OR_PROVIDED',
    PROOF_OF_ADDRESS_MANDATORY = 'PROOF_OF_ADDRESS_MANDATORY',
    ALREADY_IN_PROGRESS = 'ALREADY_IN_PROGRESS',
}

export enum EditViewName {
    FORM_VIEW = 'FORM_VIEW',
    FILE_UPLOAD_VIEW = 'FILE_UPLOAD_VIEW',
}
